import { track } from '@vercel/analytics/react';

export function trackButtonClick({ section, label, type, detail }) {
  track('Button Click', {
    section,
    label,
    type,
    ...(detail ? { detail } : {}),
  });
}
